// ChatArea.js
import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  Divider,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";

function ChatArea({ roomCode, playerUsername, socket, messages }) {
  const [message, setMessage] = useState("");
  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const handleSendMessage = (e) => {
    e.preventDefault();
    if (message.trim()) {
      socket.emit("sendMessage", { roomCode, sender: playerUsername, message });
      setMessage("");
    }
  };

  return (
    <Box
      sx={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }}
    >
      <Box
        sx={{
          p: 1.5,
          borderBottom: "1px solid",
          borderColor: "divider",
          backgroundColor: "background.default",
          flexShrink: 0,
        }}
      >
        <Typography variant="subtitle1" fontWeight={600}>
          Game Chat
        </Typography>
      </Box>

      <Box
        sx={{
          flexGrow: 1,
          overflowY: "auto",
          p: 1,
          minHeight: 0,
          backgroundColor: "background.paper",
        }}
      >
        <List dense disablePadding>
          {messages.map((msg, index) => (
            <React.Fragment key={index}>
              <ListItem sx={{ px: 1, py: 0.5 }}>
                <ListItemAvatar sx={{ minWidth: 36 }}>
                  <Avatar sx={{ width: 28, height: 28, fontSize: "0.75rem" }}>
                    {msg.sender.charAt(0).toUpperCase()}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Typography variant="body2" fontWeight={600}>
                      {msg.sender}
                    </Typography>
                  }
                  secondary={
                    <Typography variant="body2">{msg.text}</Typography>
                  }
                  sx={{ my: 0 }}
                />
              </ListItem>
              <Divider />
            </React.Fragment>
          ))}
          <div ref={messagesEndRef} />
        </List>
      </Box>

      <Box
        sx={{
          p: 1,
          borderTop: "1px solid",
          borderColor: "divider",
          backgroundColor: "background.default",
          flexShrink: 0,
        }}
      >
        <form onSubmit={handleSendMessage}>
          <Box sx={{ display: "flex", gap: 1 }}>
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              placeholder="Type a message..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 1,
                  backgroundColor: "background.paper",
                  color: "text.primary",
                },
              }}
            />
            <Button
              type="submit"
              variant="contained"
              sx={{
                minWidth: 40,
                px: 2,
                borderRadius: 1,
              }}
            >
              <SendIcon fontSize="small" />
            </Button>
          </Box>
        </form>
      </Box>
    </Box>
  );
}

export default ChatArea;
